import { render, staticRenderFns } from "./MetabaseDashboard.vue?vue&type=template&id=61c580b1&scoped=true"
import script from "./MetabaseDashboard.vue?vue&type=script&lang=js"
export * from "./MetabaseDashboard.vue?vue&type=script&lang=js"
import style0 from "./MetabaseDashboard.vue?vue&type=style&index=0&id=61c580b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c580b1",
  null
  
)

export default component.exports